// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

// Import custom Turbo Stream actions
import "./turbo_stream_actions/modal_close";
import "./turbo_stream_actions/modal_open";
import "./turbo_stream_actions/redirect";
import "./turbo_stream_actions/remove_class";

// Import Sortable.js for drag and drop functionality
import Sortable from "sortablejs";

// Suppress known non-breaking warnings from Lexxy/ActionText interaction
import "./utils/suppress-lexxy-warnings";

// Import ActiveStorage first (needed by both ActionText and Lexxy)
import "@rails/activestorage";

// Import Lexxy for rich text editing
import "@37signals/lexxy";

// Import ActionText (which includes Trix) - needed for has_rich_text fields
// Note: This may cause console warnings about missing node methods when used with Lexxy
// These warnings are non-breaking and can be ignored
import "trix";
import "@rails/actiontext";

// Import basecoat JS for interactive components (sidebar, dropdown, popover, select, tabs, toast)
// Only activates on elements with basecoat data attributes (admin views only)
import "basecoat-css/all";

// Import styles
import "dropzone/dist/dropzone.css";
import "../assets/stylesheets/application.css";

// Fallbacks for system tests (safe to load always; no-ops if Stimulus handles it)
import "./utils/mobile_menu_fallback";
